import React, { Fragment } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import ChatItem from './ChatItem';
import {
  formatTime,
  calculateTimeDifferenceBetweenChat
} from 'helpers/generic.methods';

const ChatBox = ({ title, chatHistory = [] }) => {
  const chatRenderer = chatHistory.map((chat, index) => (
    <Fragment key={index}>
      <span className="float-left mr-2">
        [
        {`${formatTime(
          chat.createdOn,
          'hh:mm:s a'
        )} ${calculateTimeDifferenceBetweenChat(
          chat.createdOn,
          chatHistory[index - 1]?.createdOn,
          '(formats)'
        )}`}
        ]
      </span>
      <ChatItem chat={chat} />
    </Fragment>
  ));
  return (
    <>
      <div className="mr-2">
        <h5 className="text-darkgray-2 fz-15 fw-700">{title}</h5>
        <div className="chat-container">
          <Scrollbars>
            <div className="chat-snippet">{chatRenderer}</div>
          </Scrollbars>
        </div>
      </div>
    </>
  );
};

export default ChatBox;
